<template>
  <div>
    <dashboard-v2 v-if="displayNewDasboard" />
    <dashboard-v1 v-if="displayNewDasboard === false" />
  </div>
</template>

<script>
import DashboardV1 from './dashboard/DashboardV1.vue';
import DashboardV2 from './dashboard/DashboardV2.vue';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';

export default {
  name: 'Dashboard',
  components: {
    DashboardV1,
    DashboardV2,
  },
  data() {
    return {
      displayNewDasboard: null,
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  async created() {
    const { data } = await getSysparameterByNames({
      parameterNames: ['DisplayNewDashboard'],
    });
    this.displayNewDasboard =
      data?.length > 0 && data[0].staticValue?.toLowerCase() == 'true';
  },
};
</script>
